import { render, staticRenderFns } from "./ResultsHistory.vue?vue&type=template&id=4c696482"
import script from "./ResultsHistory.vue?vue&type=script&lang=js"
export * from "./ResultsHistory.vue?vue&type=script&lang=js"
import style0 from "./ResultsHistory.vue?vue&type=style&index=0&id=4c696482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerCube from 'quasar/src/components/spinner/QSpinnerCube.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerCube,QTabs,QTab,QBtn,QTable,QTh,QTr,QTd,QLinearProgress,QBadge});
